export default "__VITE_ASSET__CewC$79f__"